import { useMemo } from 'react';

import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';
import { WorkspacePowerLevels } from 'modules/CreateWorkspaceModal/types';
import { DefaultRoleTypesEnum } from 'modules/Workspaces/hooks/useCreateWorkspaceRole/utils';
import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';

const ALL_ZERO: WorkspacePowerLevels = { workspace: 0, chat: 0, meeting: 0 };
const ALL_MAX: WorkspacePowerLevels = { workspace: 100, chat: 100, meeting: 100 };

const useScopedUserPowerLevels = (workspaceId: string | null, matrixId?: string): WorkspacePowerLevels => {
  const { matrixClient } = useMatrixContext();
  const { workspaceRoles, roleAssignments } = useWorkspacesContext({ requireWorkspaceId: false });

  const targetMatrixId = matrixId ?? matrixClient.getUserId();

  return useMemo<WorkspacePowerLevels>(() => {
    if (!targetMatrixId) return ALL_ZERO;
    if (!workspaceId) return ALL_MAX;

    const assignment = roleAssignments.find((entry) => entry.matrixId === targetMatrixId);
    const assignedRole = assignment ? workspaceRoles.find((role) => role.id === assignment.roleId) : undefined;
    if (assignedRole?.powerLevels) return assignedRole.powerLevels;

    const memberRole = workspaceRoles.find((role) => role.defaultRoleType === DefaultRoleTypesEnum.MEMBER);
    if (memberRole?.powerLevels) return memberRole.powerLevels;

    return ALL_ZERO;
  }, [workspaceId, targetMatrixId, workspaceRoles, roleAssignments]);
};

export default useScopedUserPowerLevels;
